import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { getSupabaseEnv, isSupabaseConfigured } from '../lib/env'

/**
 * The single Supabase client.
 *
 * Created LAZILY on first request, never at module load. Importing this module
 * during M1 to M3, when Supabase is not yet connected, must not throw: the
 * application has to boot in placeholder mode. Calling getSupabaseClient()
 * without configuration is the error, not importing the module.
 *
 * The client always runs as the signed-in user, so Row Level Security applies
 * to every request. The service role key is never used here or anywhere else in
 * browser code. See docs/SECURITY_AND_RLS.md section 10.
 *
 * Not yet used by any feature. Milestone M5 is the first consumer.
 */

let client: SupabaseClient | null = null

export function getSupabaseClient(): SupabaseClient {
  if (client !== null) return client

  const { url, anonKey } = getSupabaseEnv()
  client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  })
  return client
}

/** True when getSupabaseClient() would succeed. */
export function canCreateSupabaseClient(): boolean {
  return isSupabaseConfigured()
}

/** Test seam. Resets the memoised client so a test can vary the environment. */
export function resetSupabaseClientForTests(): void {
  client = null
}
